import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import { mdiAlert } from '@mdi/js';
import NavLink from 'client/components/aria/NavLink/NavLink';
import { HSG47_PAGE } from 'client/utils/routes/routeConstants';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

const EnquiryWarning = ({ showViewableWarning, showSafetyLink, ...props }) => {
    return (
        <div className="govuk-grid-row" {...props}>
            <div className="govuk-grid-column-full">
                {
                    showViewableWarning && <p className="govuk-body">
                        <Icon path={mdiAlert} size={0.8} className="govuk-!-margin-right-2" style={{ display: 'inline' }}/>
                        <FormattedMessage id="enquiryWarning.viewableWarning"/>
                    </p>
                }
                {
                    showSafetyLink && <NavLink className="govuk-body" to={HSG47_PAGE}>
                        <FormattedMessage id="enquiryWarning.safetyLink"/>
                    </NavLink>
                }
            </div>
        </div>
    );
};

EnquiryWarning.propTypes = {
    ...defaultAriaProps,
    showViewableWarning: PropTypes.bool,
    showSafetyLink: PropTypes.bool
};

EnquiryWarning.defaultProps = {
    showViewableWarning: true,
    showSafetyLink: true
};

export default EnquiryWarning;
